
(function() {
  var result = { translations: { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0438", "shortForm": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0432\u044A\u0442\u0440. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.1345"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1345",
    "ar-eg": "static-7.1345",
    "bg": "static-7.1345",
    "bn": "static-7.1345",
    "ca-es": "static-7.1345",
    "cs": "static-7.1345",
    "da": "static-7.1345",
    "de": "static-7.1345",
    "el": "static-7.1345",
    "en-gb": "static-7.1345",
    "en": "static-7.1345",
    "es-mx": "static-7.1345",
    "es": "static-7.1345",
    "et": "static-7.1345",
    "fi": "static-7.1345",
    "fr-ca": "static-7.1345",
    "fr": "static-7.1345",
    "he-il": "static-7.1345",
    "hi": "static-7.1345",
    "hr": "static-7.1345",
    "hu": "static-7.1345",
    "id": "static-7.1345",
    "it": "static-7.1345",
    "ja": "static-7.1345",
    "ko": "static-7.1345",
    "lt": "static-7.1345",
    "ms": "static-7.1345",
    "nl": "static-7.1345",
    "no": "static-7.1345",
    "pl": "static-7.1345",
    "pt-br": "static-7.1345",
    "pt-pt": "static-7.1345",
    "ro": "static-7.1345",
    "ru": "static-7.1345",
    "sk": "static-7.1345",
    "sl": "static-7.1345",
    "sv": "static-7.1345",
    "th": "static-7.1345",
    "tl": "static-7.1345",
    "tr": "static-7.1345",
    "uk": "static-7.1345",
    "vi": "static-7.1345",
    "x-pseudo": "static-7.1345",
    "zh-cn": "static-7.1345",
    "zh-hk": "static-7.1345",
    "zh-tw": "static-7.1345"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.1345'}); }
})();


